import React, { useState } from "react";
import { expandSchedule } from "./StepArenaPlans";

// Mirror of stepsc-admin/src/Components/Registration/DiscountCards/StepArenaPlanCard.js

const WEEKDAYS = [
    { key: 'MONDAY',    label: 'E Hënë' },
    { key: 'TUESDAY',   label: 'E Martë' },
    { key: 'WEDNESDAY', label: 'E Mërkurë' },
    { key: 'THURSDAY',  label: 'E Enjte' },
    { key: 'FRIDAY',    label: 'E Premte' },
    { key: 'SATURDAY',  label: 'E Shtunë' },
    { key: 'SUNDAY',    label: 'E Diel' },
];

export const StepArenaPlanCard = ({ section, formData, setFormData }) => {
    const [selectedPlan, setSelectedPlan] = useState(section.plans[0] || null);
    const [dropDown, setDropDown] = useState(false);
    const [pickedDays, setPickedDays] = useState([]);

    if (!selectedPlan) return null;

    const requiredDays = section.requiresDaySelection || 0;
    const needsDayPick = requiredDays > 0;
    const daysReady = !needsDayPick || pickedDays.length === requiredDays;

    const isSelected = formData?.selectedPlanId === selectedPlan.id;
    const hasDiscount =
        selectedPlan.regularPrice && selectedPlan.regularPrice !== selectedPlan.price;

    const toggleDay = (dayKey) => {
        setPickedDays((prev) => {
            if (prev.includes(dayKey)) return prev.filter((d) => d !== dayKey);
            if (prev.length >= requiredDays) return prev;
            return [...prev, dayKey];
        });
    };

    const handleChosePlan = () => {
        if (!daysReady) return;
        const discount = Math.max(
            0,
            (selectedPlan.regularPrice || 0) - (selectedPlan.price || 0)
        );
        const chosenDays = needsDayPick
            ? pickedDays.map((day) => ({ day, time: '00:00' }))
            : expandSchedule(section);
        const originalAmount = selectedPlan.regularPrice || selectedPlan.price;
        setFormData((prev) => ({
            ...prev,
            type: 'Individual',
            time: selectedPlan.time,
            totalAmount: originalAmount,
            payableAmount: selectedPlan.price,
            discount,
            entries: selectedPlan.entries,
            totalEntries: selectedPlan.entries,
            remainingEntries: selectedPlan.entries,
            premium: selectedPlan.entries === 'unlimited',
            description: `${section.title}${selectedPlan.label ? ' — ' + selectedPlan.label : ''}`,
            days: chosenDays,
            tempDays: chosenDays,
            selectedPlanId: selectedPlan.id,
        }));
    };

    return (
        <div className="flex flex-col gap-5 border-[#003DFE] border-2 rounded-lg min-w-[300px] p-5 h-fit font-custom2">
            <div className="flex flex-col gap-2 rounded-2xl relative w-[200px]">
                <button
                    onClick={() => setDropDown((d) => !d)}
                    type="button"
                    className="text-blue-700 bg-[#D5DFFF] bg-opacity-60 font-medium rounded-lg text-sm px-5 py-1.5 text-center inline-flex items-center"
                >
                    {selectedPlan.label}
                    <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                    </svg>
                </button>

                <div className={`z-10 bg-white text-black -right-1 top-10 absolute divide-y divide-gray-100 rounded-lg shadow w-44 ${dropDown ? 'block' : 'hidden'}`}>
                    <ul className="py-2 text-sm">
                        {section.plans.map((plan) => (
                            <li key={plan.id}>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedPlan(plan);
                                        setDropDown(false);
                                    }}
                                    className="block px-4 py-2 hover:bg-gray-200"
                                >
                                    {plan.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="flex flex-col gap-3">
                <span>
                    Hyrjet:{' '}
                    {selectedPlan.entries === 'unlimited' ? 'Të pakufizuara' : selectedPlan.entries}
                </span>
                <span className="flex items-baseline gap-2">
                    Çmimi:
                    {hasDiscount && (
                        <span className="text-sm text-gray-400 line-through">
                            {selectedPlan.regularPrice}€
                        </span>
                    )}
                    <span className="font-bold">{selectedPlan.price} €</span>
                </span>

                {needsDayPick && (
                    <div className="flex flex-col gap-2">
                        <span className="text-sm text-gray-600">
                            Zgjidh {requiredDays} ditë në javë:
                        </span>
                        <div className="flex flex-wrap gap-2">
                            {WEEKDAYS.map((d) => {
                                const active = pickedDays.includes(d.key);
                                const atCap = !active && pickedDays.length >= requiredDays;
                                return (
                                    <button
                                        key={d.key}
                                        type="button"
                                        onClick={() => toggleDay(d.key)}
                                        disabled={atCap}
                                        className={`px-3 py-1 rounded-md text-xs font-semibold border transition-all
                                            ${active
                                                ? 'bg-[#003DFE] text-white border-[#003DFE]'
                                                : atCap
                                                    ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                                                    : 'bg-white text-[#003DFE] border-[#003DFE] hover:bg-[#D5DFFF]'}
                                        `}
                                    >
                                        {d.label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                <button
                    onClick={handleChosePlan}
                    type="button"
                    disabled={!daysReady}
                    className={`min-w-full border-[#003DFE] font-bold border-2 rounded-lg p-1 transition-all duration-300
                        ${!daysReady
                            ? 'opacity-50 cursor-not-allowed text-[#003DFE]'
                            : isSelected
                                ? 'bg-[#003DFE] text-white'
                                : 'text-[#003DFE] hover:bg-[#003DFE] hover:text-white'}`}
                >
                    {isSelected ? 'Përzgjidh Planin' : 'Zgjidh Planin'}
                </button>
            </div>
        </div>
    );
};

export default StepArenaPlanCard;
